interface SvgImage {
  alt: string;
  src: string;
}

const availablePaymentProviders = {
  VISA: { alt: 'visa icon', src: '/icons/payment-providers/visa.svg' },
  MASTERCARD: { alt: 'mastercard icon', src: '/icons/payment-providers/mastercard.svg' },
  DISCOVER: { alt: 'discover icon', src: '/icons/payment-providers/discover.svg' },
  AMEX: { alt: 'amex icon', src: '/icons/payment-providers/amex.svg' },
  PAYPAL: { alt: 'paypal icon', src: '/icons/payment-providers/paypal.svg' },
  PAYPAL_SECURE: { alt: 'paypal secure icon', src: '/icons/payment-providers/paypal2.svg' },
  GPAY: { alt: 'google pay icon', src: '/icons/payment-providers/gpay.svg' },
  CUP: { alt: 'union pay icon', src: '/icons/payment-providers/cup.svg' },
  DINERS: { alt: 'diners icon', src: '/icons/payment-providers/diners.svg' },
  BANK_TRANSFER: { alt: 'bank transfer icon', src: '/icons/payment-providers/directEbanking.svg' },
  EPS: { alt: 'eps icon', src: '/icons/payment-providers/eps.svg' },
  BCMC: { alt: 'bcmc icon', src: '/icons/payment-providers/bcmc.svg' },
  TRUSTLY: { alt: 'trustly icon', src: '/icons/payment-providers/trustly.svg' },
  GIRO: { alt: 'giro pay icon', src: '/icons/payment-providers/giropay.svg' },
  IDEAL: { alt: 'iDeal icon', src: '/icons/payment-providers/ideal.svg' },
};

const braintreePaymentOptions = [
  availablePaymentProviders.VISA,
  availablePaymentProviders.MASTERCARD,
  availablePaymentProviders.DISCOVER,
  availablePaymentProviders.AMEX,
  availablePaymentProviders.GPAY,
  availablePaymentProviders.PAYPAL_SECURE,
];

const paymentProvidersData: { [key: string]: SvgImage[] } = {
  US: braintreePaymentOptions,
  GB: [
    availablePaymentProviders.VISA,
    availablePaymentProviders.MASTERCARD,
    availablePaymentProviders.DISCOVER,
    availablePaymentProviders.GPAY,
    availablePaymentProviders.PAYPAL_SECURE,
  ],
  AT: [
    availablePaymentProviders.VISA,
    availablePaymentProviders.MASTERCARD,
    availablePaymentProviders.DISCOVER,
    availablePaymentProviders.DINERS,
    availablePaymentProviders.AMEX,
    availablePaymentProviders.CUP,
    availablePaymentProviders.BANK_TRANSFER,
    availablePaymentProviders.EPS,
    availablePaymentProviders.PAYPAL_SECURE,
  ],
  BE: [
    availablePaymentProviders.VISA,
    availablePaymentProviders.MASTERCARD,
    availablePaymentProviders.DISCOVER,
    availablePaymentProviders.DINERS,
    availablePaymentProviders.AMEX,
    availablePaymentProviders.CUP,
    availablePaymentProviders.BANK_TRANSFER,
    availablePaymentProviders.BCMC,
    availablePaymentProviders.PAYPAL_SECURE,
  ],
  EE: braintreePaymentOptions,
  FI: [
    availablePaymentProviders.VISA,
    availablePaymentProviders.MASTERCARD,
    availablePaymentProviders.DISCOVER,
    availablePaymentProviders.DINERS,
    availablePaymentProviders.AMEX,
    availablePaymentProviders.CUP,
    availablePaymentProviders.TRUSTLY,
    availablePaymentProviders.PAYPAL_SECURE,
  ],
  FR: braintreePaymentOptions,
  DE: [
    availablePaymentProviders.VISA,
    availablePaymentProviders.MASTERCARD,
    availablePaymentProviders.DISCOVER,
    availablePaymentProviders.DINERS,
    availablePaymentProviders.AMEX,
    availablePaymentProviders.CUP,
    availablePaymentProviders.BANK_TRANSFER,
    availablePaymentProviders.GIRO,
    availablePaymentProviders.PAYPAL_SECURE,
  ],
  GR: braintreePaymentOptions,
  IE: braintreePaymentOptions,
  IT: braintreePaymentOptions,
  LU: braintreePaymentOptions,
  MC: braintreePaymentOptions,
  NL: [
    availablePaymentProviders.VISA,
    availablePaymentProviders.MASTERCARD,
    availablePaymentProviders.DISCOVER,
    availablePaymentProviders.DINERS,
    availablePaymentProviders.AMEX,
    availablePaymentProviders.CUP,
    availablePaymentProviders.IDEAL,
    availablePaymentProviders.PAYPAL_SECURE,
  ],
  PL: braintreePaymentOptions,
  PT: braintreePaymentOptions,
  SK: braintreePaymentOptions,
  SI: braintreePaymentOptions,
  ES: braintreePaymentOptions,
  CA: braintreePaymentOptions,
  CZ: braintreePaymentOptions,
  DK: braintreePaymentOptions,
  LT: braintreePaymentOptions,
  NO: braintreePaymentOptions,
  CH: braintreePaymentOptions,
  SE: braintreePaymentOptions,
  AU: braintreePaymentOptions,
  JP: braintreePaymentOptions,
  KR: braintreePaymentOptions,
  HR: braintreePaymentOptions,
  NZ: braintreePaymentOptions,
  SG: braintreePaymentOptions,
  PH: braintreePaymentOptions,
  ZA: braintreePaymentOptions,
  VE: braintreePaymentOptions,
  CL: braintreePaymentOptions,
  TH: braintreePaymentOptions,
  AE: braintreePaymentOptions,
  HK: braintreePaymentOptions,
  FO: braintreePaymentOptions,
  GL: braintreePaymentOptions,
  GG: braintreePaymentOptions,
  IS: braintreePaymentOptions,
  IL: braintreePaymentOptions,
  JE: braintreePaymentOptions,
  MY: braintreePaymentOptions,
  RE: braintreePaymentOptions,
  BL: braintreePaymentOptions,
  MF: braintreePaymentOptions,
  SA: braintreePaymentOptions,
  SX: braintreePaymentOptions,
  TW: braintreePaymentOptions,
  DEFAULT: braintreePaymentOptions,
};

export const paymentProviders = (countryCode?: string) => {
  if (!countryCode) return paymentProvidersData.DEFAULT;

  return paymentProvidersData[countryCode]
    ? paymentProvidersData[countryCode]
    : paymentProvidersData.DEFAULT;
};
